
import { defineComponent } from "vue";
export default defineComponent({
    emits: ["update:toggle", "toggleChanged"],
    props: {
        toggle: {
            type: Boolean,
            default: false,
        },
        hasClose: {
            type: Boolean,
            default: true,
        },
        hasTitle: {
            type: Boolean,
            default: true,
        },
        isBottom: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        toggle: function (val) {
            if (this.toggle)
                $(this.$refs.modal).modal("show");
            else
                $(this.$refs.modal).modal("hide");
        }
    },
    methods: {
        closePopup() {
            $(this.$refs.modal).modal('hide');
            this.changeToggle(false);
        },
        changeToggle(val: boolean) {
            this.$emit("update:toggle", val);
            this.$emit("toggleChanged", val);
        }
    },
    mounted() {
        const vm = this;
        const modal = vm.$refs.modal;
        $(modal)
            .off("hide.bs.modal")
            .on("hide.bs.modal", function () {
                vm.changeToggle(false);
            });
    },
});
